import { STAGE_LABEL, fmt, type StageResult } from "@h2lca/core";
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { CHART_LAYOUT, css, STAGE_COLOR } from "@/lib/design";
import { ChartTip } from "./ChartTip";

/** 단계별 배출량 세로 막대 , 네 단계, 단계색. 값은 막대 위에 직접 적는다(네 개뿐이라) */
export function StageBarChart({ byStage }: { byStage: StageResult[] }) {
  const data = byStage.map((s) => ({ stage: s.stage, name: STAGE_LABEL[s.stage], kgCO2eq: s.kgCO2eq, share: s.share }));
  return (
    <div className="ws-chart chart-stage w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: CHART_LAYOUT.stageTopMargin, right: CHART_LAYOUT.stageRightMargin, left: 0, bottom: 0 }} barCategoryGap="30%">
          <CartesianGrid vertical={false} />
          <XAxis dataKey="name" tickLine={false} axisLine={false} />
          <YAxis tickLine={false} axisLine={false} width={CHART_LAYOUT.stageYAxisWidth} tickFormatter={(v: number) => fmt(v, 0)} />
          <Tooltip content={<ChartTip />} cursor={{ fill: css("--color-surface-sunken") }} />
          <Bar dataKey="kgCO2eq" maxBarSize={CHART_LAYOUT.stageBarMax} radius={[CHART_LAYOUT.stageBarRadius, CHART_LAYOUT.stageBarRadius, 0, 0]} isAnimationActive={false}>
            {data.map((d) => (
              <Cell key={d.stage} fill={css(STAGE_COLOR[d.stage].fill)} />
            ))}
            <LabelList dataKey="kgCO2eq" position="top" formatter={(v: unknown) => fmt(Number(v))} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
